<template>
	<v-dialog :value="value" max-width="520" @input="$emit('input', $event)">
		<v-card class="evaluation-comment-dialog">
			<v-card-title class="evaluation-comment-header d-flex align-center justify-space-between pa-5 pb-4">
				<h2 class="evaluation-comment-title mb-0">Evaluation comment</h2>
				<v-btn
					icon
					small
					aria-label="Close"
					@click="close"
				>
					<v-icon size="18">fas fa-times</v-icon>
				</v-btn>
			</v-card-title>

			<v-divider />

			<v-card-text class="pa-5 pt-4 pb-6">
				<p class="evaluation-comment-text mb-0">{{ displayComment }}</p>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "EvaluationCommentDialog",
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		comment: {
			type: String,
			default: "",
		},
	},
	computed: {
		displayComment() {
			const trimmed = (this.comment || "").trim()
			return trimmed || "No comment provided for this evaluation."
		},
	},
	methods: {
		close() {
			this.$emit("input", false)
		},
	},
}
</script>

<style scoped>
.evaluation-comment-dialog {
	border-radius: 10px;
	overflow: hidden;
}

.evaluation-comment-title {
	font-size: 1.125rem;
	font-weight: 700;
	color: #1a1a1a;
}

.evaluation-comment-text {
	color: #424242;
	font-size: 0.9375rem;
	line-height: 1.55;
	white-space: pre-wrap;
}

</style>
